// extracted by mini-css-extract-plugin
module.exports = {"WidgetArea":"WidgetArea_WidgetArea__3v9Kg","capped-width":"WidgetArea_capped-width__2gK7E"};